import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=60b231bb&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=60b231bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b231bb",
  null
  
)

export default component.exports